// logout.component.ts
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppComponent } from '../../../app.component';
import { AuthService } from '../../../core/auth/auth.service';

@Component({
  selector: 'app-logout',
  template: `<p>logout in process...</p>`,
})
export class LogoutComponent implements OnInit, OnDestroy {
  private logoutSubscription: Subscription | undefined;

  constructor(private msalService: MsalService, private router: Router,private appComponent: AppComponent, private authService:AuthService) {}

  ngOnInit(): void {
 
    this.logoutSubscription = this.msalService.logoutRedirect({
      postLogoutRedirectUri: '/',
    }).subscribe({
      next: () => {
      
        this.appComponent.isLoggedIn = false;
        this.authService.resetAccessToken();
        // Ações adicionais após o logout podem ser realizadas aqui
        this.router.navigate(['/']);
      },
      error: (error) => {
        console.error('Erro durante o logout:', error);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.logoutSubscription) {
      this.logoutSubscription.unsubscribe();
    }
  }
}
